


















































































































































// Vue
import { defineComponent, PropType, computed, ref, Ref, onMounted } from '@vue/composition-api'

// components
import { Form, Input, Button, Icon, DatePicker, Select2, Select, Radio } from '@/components/general'
import { Loading } from '@/components'

// models
import { PropOptionSelect } from '@/models'
import { DiscountControl, DiscountControlForm } from '@/models/dailyControl'
import { DiscountTypeModel, IEmployee, AreaModel } from '@/models/config'

// services
import { EmployeeService, DiscountTypesService, AreaService } from '@/services/config'
import { DiscountControlService } from '@/services/dailyControl'

// Vuelidate
import useVuelidate from '@vuelidate/core'
import { required, requiredIf } from '@vuelidate/validators'

// utils
import { alerts, loading, getFullNameFormat } from '@/utils'
import { getListDateAvailable } from '@/utils/employee'

// constants
import { optionsDiscountTypes, TYPE_AMOUNT, TYPE_PERCENTAGE, optionsFrequencyDiscount } from '@/constants/discountTypeConstants'

export default defineComponent({
  name: 'DiscountControlFormCreateEdit',
  components: {
    Form,
    Input,
    Button,
    Icon,
    DatePicker,
    Select2,
    Select,
    Loading,
    Radio
  },
  props: {
    item: {
      type: Object as PropType<DiscountControlForm>,
      required: true
    },
    idEdit: {
      type: Number as PropType<number>,
      default: null
    },
    action: {
      type: String as PropType<'save'|'update'>,
      required: true
    }
  },
  setup (props, { emit }) {
    const isLoading = ref(true)
    const typeForm = ref(1)
    const optionsTypeForm = ref([
        {
            text: 'POR EMPLEADO',
            value: 1
        },
        {
            text: 'POR ÁREA',
            value: 2
        }
    ])
    const areaSelectedId: Ref<number|null> = ref(null)
    const subAreaSelectedId: Ref<number|null> = ref(null)
    const employeesSelected: Ref<number[]> = ref([])
    const areas: Ref<AreaModel[]> = ref([])
    const getAreas = async () => {
        areas.value = await AreaService.getActivated()
    }
    getAreas()

    const areasOp: Ref<PropOptionSelect[]> = computed(() => {
      return areas.value.map(area => ({
        value: area.id ?? null,
        text: area.name
      }))
    })

    const subAreasOP: Ref<PropOptionSelect[]> = computed(() => {
      if (areaSelectedId.value) {
        const area = areas.value.find(area => Number(area.id) === Number(areaSelectedId.value))
        if (area) {
          return area?.subAreas && area.subAreas.length > 0 ? area.subAreas.map(area => ({
              value: area.id ?? null,
              text: area.name
          })) : []
        }
      }
      return []
    })
    const rules = computed(() => ({
      item: {
        employee_id: {
          required: requiredIf(() => props.action !== 'save' || typeForm.value === 1)
        },
        discount_type_id: { required },
        type: { required },
        date: { required },
        amount: { required },
        frequency: { required }
      },
      areaSelectedId: {
        required: requiredIf(() => props.action === 'save' && typeForm.value === 2)
      },
      subAreaSelectedId: {
        required: requiredIf(() => props.action === 'save' && typeForm.value === 2)
      }
    }))
    const $v = useVuelidate(rules, {
      item: props.item,
      areaSelectedId: areaSelectedId.value,
      subAreaSelectedId: subAreaSelectedId.value
    })

    const allEmployees: Ref<IEmployee[]> = ref([])
    const dateAvailable: Ref<string[]> = ref([])
    const employeesOp = computed(() => {
      return allEmployees.value.filter(employee => subAreaSelectedId.value ? Number(employee.assignment.sub_area_id) === Number(subAreaSelectedId.value) : true)
      .map(employee => ({
        value: employee.id || null,
        text: getFullNameFormat(employee)
      }))
    })

    const employeeSelected = computed(() => {
      if (props.item.employee_id && employeesOp.value.find(employee => employee.value === props.item.employee_id)) {
        const employee = allEmployees.value.find(e => e.id === props.item.employee_id)
        if (employee) {
          return employee
        }
      }
      return null
    })

    const allDiscountTypes: Ref<DiscountTypeModel[]> = ref([])
    const discountControlEmployee: Ref<DiscountControl[]> = ref([])
    const getDiscountControlByEmployee = async () => {
      discountControlEmployee.value = await DiscountControlService.getAll({
        dateStart: null,
        dateEnd: null,
        employee: props.item.employee_id,
        discountType: null
      })
    }

    const allDiscountTypesOp = computed(() => {
      return allDiscountTypes.value.map(discountType => ({
        value: discountType.id ?? null,
        text: discountType.name
      }))
    })

    const discountTypesOp = computed(() => {
      return allDiscountTypes.value.filter(type => {
        const exists = discountControlEmployee.value.find(d => d.discount_type_id === type.id)
        return !exists
      }).map(type => {
        return {
          value: type.id,
          text: type.name
        }
      })
    })

    const setListDateAvailable = () => {
      discountControlEmployee.value = []
      props.item.discount_type_id = null
      if (props.item.employee_id && employeeSelected.value) {
        const listDate = getListDateAvailable(employeeSelected.value.cessation)
        dateAvailable.value = listDate
        getDiscountControlByEmployee()
      }
    }

    onMounted(async () => {
      allEmployees.value = await EmployeeService.getActivated()
      allDiscountTypes.value = await DiscountTypesService.getActivated()
      isLoading.value = false
    })

    const save = async () => {
      $v.value.item.$touch()
      if (!$v.value.item.$invalid) {
        try {
          loading('show')
          if (props.action === 'save') {
            if (typeForm.value === 1) {
              await DiscountControlService.create(props.item)
            } else {
              for (let i = 0; i < employeesSelected.value.length; i++) {
                const item = {
                  ...props.item,
                  employee_id: employeesSelected.value[i]
                }
                const discountControlEmployee = await DiscountControlService.getAll({
                  dateStart: null,
                  dateEnd: null,
                  employee: item.employee_id,
                  discountType: null
                })
                const exists = discountControlEmployee.find(d => d.discount_type_id === item.discount_type_id)
                const employee = allEmployees.value.find(e => e.id === item.employee_id)
                if (exists && employee) {
                  loading('hide')
                  alerts.error(`El empleado ${getFullNameFormat(employee)}, ya tiene el descuento seleccionado!`)
                  return
                }
              }
              for (let i = 0; i < employeesSelected.value.length; i++) {
                const item = {
                  ...props.item,
                  employee_id: employeesSelected.value[i]
                }
                await DiscountControlService.create(item)
              }
            }
          } else {
            await DiscountControlService.update(props.idEdit, props.item)
          }
          loading('hide')
          alerts.success()
          emit('save-success')
        } catch (e) {
          alerts.error(String(e))
          loading('hide')
        }
      } else {
        alerts.error('Debe completar todos los campos')
      }
    }

    const changediscountType = () => {
      if (props.item.discount_type_id && Number(props.item.discount_type_id) === 1) {
          props.item.type = TYPE_PERCENTAGE
      } else {
        props.item.type = TYPE_AMOUNT
      }
    }
    const setAllEmployeesBySubArea = (_subAreaSelectedId: number) => {
      props.item.employee_id = null
      subAreaSelectedId.value = _subAreaSelectedId
      if (subAreaSelectedId.value) {
          employeesSelected.value = allEmployees.value.filter(employee => Number(employee.assignment.sub_area_id) === Number(_subAreaSelectedId)).map(employee => employee.id)
      } else {
          employeesSelected.value = []
      }
    }
    return {
      save,
      $v,
      employeesOp,
      isLoading,
      optionsDiscountTypes,
      discountTypesOp,
      TYPE_PERCENTAGE,
      TYPE_AMOUNT,
      setListDateAvailable,
      dateAvailable,
      employeeSelected,
      changediscountType,
      optionsFrequencyDiscount,
      typeForm,
      optionsTypeForm,
      setAllEmployeesBySubArea,
      areaSelectedId,
      subAreaSelectedId,
      employeesSelected,
      areasOp,
      subAreasOP,
      allDiscountTypesOp
    }
  }
})
